import React from "react";
void React;
import PageHero from "@/components/UI/PageHero";
import ImageText from "@/components/UI/ImageText";
import FeatureCardSection from "@/components/UI/CardSection";
import Timeline from "@/components/UI/Timeline";
import ContainerExamples from "@/components/UI/ContainerExample";
import LandingFooter from "@/components/UI/LandingFooter";
import IconText from "@/components/UI/IconText";
import dollar from "@/public/svg/dollar-green.svg";
import handshake from "@/public/svg/handshake.svg";
import market from "@/public/svg/market.svg";
import mobileShopping from "@/public/svg/mobile-shopping.svg";
import gerste from "@/public/img/gerste.jpg";
import globeHouse from "@/public/svg/eco_globe_house.svg";
import house from "@/public/svg/eco_house.svg";
import humanMind from "@/public/svg/eco_human_mind.svg";
import leafSettings from "@/public/svg/leaf_settings.svg";
import plantHand from "@/public/svg/plant_hand.svg";
import knittelsheim from "@/public/img/knittelsheim.jpg";
import testkunde from "@/public/img/Testkundenaktion.jpeg";
import schwanheim from "@/public/img/schwanheim-innen.jpg";
import StoreReviews from "@/components/UI/StoreReviews";
import MunicipalitiesFaqAccordions from "@/components/UI/MunicipalitiesFaqAccordions";
import SeoHelmet from "@/components/UI/SeoHelmet";
import seoImg from "@/public/img/seo/gemeinden.png";
import yobstiLaden from "@/public/img/yobsti-laden.png";
import voelkersweiler from "@/public/img/voelkersweiler-innen.jpg";
import huttenheimImg from "@/public/img/laden_huttenheim.jpg";
import { track } from '@/helpers/analytics';

export default function FaqMunicipalities() {
    return (
        <>
            <SeoHelmet
                title="Yobsti für Gemeinden – Moderner Dorfladen ohne Personal auch in deiner Gemeinde"
                description="Zukunft sichern. Nahversorgung stärken. Leben auf dem Land erleichtern."
                image={seoImg}
                url="https://www.yobsti.de/fuer-gemeinden"
            />

            <PageHero
                eyebrow="Für Gemeinden"
                title={<>Zukunft sichern.<br />Nahversorgung stärken.<br />Leben auf dem Land erleichtern.</>}
                text="Yobsti ist der moderne Dorfladen ohne Personal – mit langen Öffnungszeiten. Entwickelt für Gemeinden unter 5.000 Einwohnern."
                illustration={yobstiLaden}
            />

            <a
                href="/gemeindeformular"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => track('cta-click', { target: 'municipality-form', location: 'municipalities-sticky' })}
                className="fixed right-0 top-[80%] -translate-y-1/2 bg-secondary text-textColor font-semibold px-4 py-3 rounded-l-full shadow hover:bg-primary cursor-pointer transition z-50"
            >
                Jetzt unverbindlich<br />Standort prüfen lassen
            </a>

            <ImageText
                title="Yobsti – der Dorfladen, der mitdenkt"
                text={`
                    <p><strong>Mehr als ein Laden. Ein Versprechen an Ihre Bürger:innen.</strong></p>
                    <p class="mt-2">Mit Yobsti holen Sie ein Stück Heimat zurück ins Dorf:</p>
                    <ul class="list-disc list-inside mt-2 text-left">
                    <li>Frische Lebensmittel direkt im Ort</li>
                    <li>Einfach zugänglich – auch für Ältere und Familien</li>
                    <li>Regional gedacht, digital gemacht</li>
                    </ul>
                    <p class="mt-4">Ein Treffpunkt, der verbindet. Eine Lösung, die bleibt.</p>
                    <p>Ob als kleiner Laden oder moderner Container: <strong>Yobsti funktioniert ohne Personal</strong>, ist <strong>barrierefrei</strong> und <strong>sicher</strong> – angepasst an die Bedürfnisse Ihrer Gemeinde.</p>
                `}
                imageUrl={testkunde}
                imageAlt="Gerste"
                imageLeft
            />

            <IconText
                features={[
                    {
                        icon: dollar,
                        alt: "Dollar",
                        text: "Keine Kosten für die Gemeinde. Yobsti plant, finanziert und betreibt selbst",
                    },
                    {
                        icon: globeHouse,
                        alt: "globe House",
                        text: "Nahversorgung sichern, auch wenn es keine Bäckerei oder Metzgerei mehr gibt",
                    },
                    {
                        icon: handshake,
                        alt: "Handshake",
                        text: "Regionale Landwirte einbinden. Wertschöpfung bleibt vor Ort",
                    },
                    {
                        icon: market,
                        alt: "Market",
                        text: "Einfach & schnell realisierbar, ohne Personal, ohne Verwaltungsaufwand",
                    },
                    {
                        icon: mobileShopping,
                        alt: "Mobile Shopping",
                        text: "Ein starkes Signal für Lebensqualität & Digitalisierung auf dem Land",
                    },
                ]}
            />

            <FeatureCardSection
                heading="Warum Yobsti?"
                cards={[
                    {
                        icon: globeHouse,
                        title: "Lebensqualität vor Ort sichern",
                        subtitle: "Nahversorgung direkt im Ort – für Jung & Alt.",
                    },
                    {
                        icon: plantHand,
                        title: "Regionale Wirtschaft stärken",
                        subtitle: "Plattform für Direktvermarkter und Erzeuger.",
                    },
                    {
                        icon: leafSettings,
                        title: "Unkomplizierte Umsetzung",
                        subtitle: "Kein Personal, keine Betriebspflicht für die Gemeinde.",
                    },
                    {
                        icon: humanMind,
                        title: "Modernes Dorfprofil",
                        subtitle: "Digitalisierung sichtbar und alltagstauglich einsetzen.",
                    },
                    {
                        icon: house,
                        title: "Flexibilität durch Containerlösung",
                        subtitle: "Rückbaubar, skalierbar, förderfähig.",
                    },
                ]}
            />

            <ImageText
                title="Ein echter Dorfladen – aber digital gedacht"
                list={[
                    "Zugang per Karte",
                    "Sortiment: 700+ Artikel",
                    "vollständig digital verwaltet",
                    "Fokus auf Frische, Regionalität & Alltagstauglichkeit",
                    "Nutzung durch alle Generationen",
                    "Öffnungszeiten nach Wunsch der Gemeinde",
                    "Sozialer Ankerpunkt – wenn gewünscht, mit Unterstützung für lokale Treffpunkte",
                ]}
                imageUrl={gerste}
                imageAlt="Gerste"
                bgColor="sand"
            />

            <StoreReviews />

            <ContainerExamples
                title="Aktuelle Projekte & Gemeinden in Umsetzung"
                subtitle="Immer mehr Orte entscheiden sich für Yobsti."
                text="Ob als Container am Sportplatz oder als Laden im alten Gemeindezentrum – gemeinsam mit engagierten Bürger:innen und mutigen Kommunen setzen wir neue Maßstäbe in der Nahversorgung."
                bgColor="sand"
                examples={[
                    {
                        imageUrl: knittelsheim,
                        location: "Knittelsheim (RLP)",
                        quote: "Umbau Alte Bäckerei in der Ortsmitte, seit Dezember 2024",
                    },
                    {
                        imageUrl: voelkersweiler,
                        location: "Völkersweiler (RLP)",
                        quote: "Containerlösung in der Ortsmitte, seit Sommer 2025",
                    },
                    {
                        imageUrl: schwanheim,
                        location: "Schwanheim (RLP)",
                        quote: "Ehemaliges Dorfcafe in der Ortsmitte, seit Sommer 2025",
                    },
                    {
                        imageUrl: huttenheimImg,
                        location: "Huttenheim (BW)",
                        quote: "Laden im Neubau in der Ortsmitte, seit Sommer 2025",
                    },
                ]}
            />

            <Timeline
                heading="Der Weg zum eigenen Yobsti"
                subtitle={`<h2 class="text-xl font-bold mb-4">In 4 Schritten zum eigenen Yobsti – ohne Risiko für Ihre Gemeinde</h2>
                        <p class="mb-4">
                        Sie möchten die Nahversorgung sichern, ohne selbst Ladenbetreiber zu werden?<br />
                        Mit Yobsti bringen Sie Lebensmittel, Begegnung und Versorgungssicherheit zurück in Ihre Gemeinde – ganz ohne laufende Kosten oder Verwaltungsaufwand.
                        Wir kümmern uns um alles: von der Planung bis zum Betrieb.
                        Was Sie brauchen, ist nur ein bisschen Fläche und die Bereitschaft, neue Wege zu gehen.
                        </p>
                        <p class="mb-4 font-semibold">
                        Einfach. Durchdacht. Komplett übernommen.<br />
                        So bringen Sie mit uns moderne Nahversorgung in Ihren Ort:
                        </p>
                    `}
                steps={[
                    {
                        title: "Interesse bekunden",
                        description: "Füllen Sie unser kurzes Online-Formular aus – wir melden uns persönlich bei Ihnen.",
                    },
                    {
                        title: "Machbarkeitsstudie & Standortanalyse",
                        description:
                            "Wir prüfen, ob ein Yobsti in Ihrer Gemeinde realisierbar ist – inklusive Datenanalyse, Bedarf und möglicher Flächen.",
                    },
                    {
                        title: "Konkretes Umsetzungskonzept",
                        description:
                            "Sie erhalten von uns ein vollständiges Konzept – mit Zeitplan, Standortvorschlag und lokalem Produktangebot.",
                    },
                    {
                        title: "Bau & Betrieb durch Yobsti",
                        description:
                            "Nach Ihrer Zustimmung übernehmen wir alles: Technik, Logistik, Betrieb. Ihre Gemeinde bleibt Gastgeber – ohne Aufwand.",
                    },
                ]}
            />

            <section className="bg-secondaryLight py-12">
                <div className="max-w-3xl mx-auto text-center px-6">
                    {/* <p className="text-lg mb-2">Sie möchten sich erst einen Überblick verschaffen?</p>
                    <p className="text-lg mb-6">
                        Laden Sie unser kompaktes Info-PDF herunter – ideal für Gemeinderat, Kolleg:innen oder interne Abstimmungen.
                    </p>

                    <a
                        href=""
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block bg-lineGreen text-textColor font-semibold px-6 py-3 rounded-full shadow hover:bg-primaryDark transition"
                    >
                        Info-PDF
                    </a> */}

                    <p className="text-lg m-6">Bereit, den ersten Schritt zu gehen?</p>

                    <a
                        href="/gemeindeformular"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => track('cta-click', { target: 'municipality-form', location: 'municipalities' })}
                        className="inline-block bg-lineGreen text-textColor font-semibold px-6 py-3 rounded-full shadow hover:bg-primaryDark transition"
                    >
                        Jetzt unverbindlich Standort prüfen lassen
                    </a>
                </div>
            </section>

            <MunicipalitiesFaqAccordions />

            <LandingFooter
                phoneNumber="+49 1512 1676362"
                availability="Mo–Fr, 10–15 Uhr"
                formUrl="/gemeindeformular"
            />
        </>
    );
}
